import { config } from '@services/config';
import { ProductOptionSearchResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useProductOptions = (insuranceProductId?: string) => {
  const client = useClient();
  const queryParams = new URLSearchParams();
  queryParams.append('sort', '+name');
  queryParams.append('pageLimit', '1000');
  const result = useQuery<ProductOptionSearchResponse, Error>({
    queryKey: ['productOptions', { insuranceProductId }],
    queryFn: async () =>
      client
        .get(`insurance-product/${insuranceProductId}/product-option?${queryParams}`)
        .json<ProductOptionSearchResponse>(),
    enabled: !!insuranceProductId,
    ...config,
  });
  return { ...result, productOptions: { ...result.data, items: result.data?.items ?? [] } };
};
